import { isObject } from "@perxis-auto/shared";
function instanceOfFilterRange(object) {
  return isObject(object) && "min" in object && "max" in object;
}
export {
  instanceOfFilterRange
};
